import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { merge } from 'rxjs';
import { BehaviorSubject, Subscription } from 'rxjs';
import { share } from 'rxjs/operators';

@Component({
  selector: 'gt-invalid-feedback',
  templateUrl: './invalid-feedback.component.html',
  styles: ['.error {color: red}']
})
export class InvalidFeedbackComponent implements OnInit, OnDestroy {

  @Input() form?: FormGroup;
  @Input() fieldname?: string;

  private isDirty$$ = new BehaviorSubject<boolean>(false);
  isDirty$ = this.isDirty$$.pipe(share());

  private isInvalid$$ = new BehaviorSubject<boolean>(false);
  isInvalid$ = this.isInvalid$$.pipe(share());

  private errors$$ = new BehaviorSubject<string[]>([]);
  errors$ = this.errors$$.pipe(share());

  private subs = new Subscription();

  constructor() { }

  ngOnInit() {
    if (this.form && this.fieldname) {
      this.subs.add(
        merge(
          this.form.valueChanges,
          this.form.statusChanges
        ).subscribe(() => {
          this.isInvalid$$.next(this.form?.get(this.fieldname as string)?.invalid || false);
          this.isDirty$$.next(this.form?.get(this.fieldname as string)?.dirty || false);
          this.errors$$.next(Object.keys(this.form?.get(this.fieldname as string)?.errors || {}));
        })
      );
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}
